import { OneTrustSettingsButton } from "./OneTrustSettingsButton";

export { OneTrustSettingsButton };
